import { delay } from "redux-saga";
import { put, call, select } from "redux-saga/effects";
import axios from "axios";
import {baseUrl} from '../../common/config.js';
const qs = require('querystring');
import {getPlayerTypeList, getRolesAndBusiness, getUsersList, getCoachList} from '../../endPoints/appUser'

import * as actions from "../actions/index";
import * as selectors from '../selectors';

export function* getPlayerTypeListSaga() {
    try{
        const response = yield call(getPlayerTypeList)      
        yield put(actions.setPlayerTypeList(response.data))
    } catch(err) {
        console.log(err);
    }
}

const getSelcRolesAndBuss = (roles, business) => {
    let selectedRoles = []
    selectedRoles = roles.map(function(id) { return id._id})
    let selectedBusiness = []
    selectedBusiness = business.map(function(id) {return id._id})
    return {
        selectedRoles, selectedBusiness
    }
}

export function* getRolesAndBusinessSaga() {
    try{
        const response1 = yield call(getRolesAndBusiness)
        let rolesAndBuss = getSelcRolesAndBuss(response1.data.roles, response1.data.buss)
        yield put(actions.setRolesAndBusiness(response1.data.roles, response1.data.buss, rolesAndBuss.selectedRoles, rolesAndBuss.selectedBusiness))
        const response2 = yield call(getUsersList, {max: 10, offset:0, sortBy:'asc', column:'first_name', selectedRoles: rolesAndBuss.selectedRoles, business: rolesAndBuss.selectedBusiness, username:'', first_name:'', last_name:'', alias:'', playerType:'', assigned_to:'', userRole:localStorage.getItem('userRole')})
        yield put(actions.setUsersList(response2.data.usersList, response2.data.count))
        const response3 = yield call(getCoachList, {business: rolesAndBuss.selectedBusiness})
        yield put(actions.setCoachList(response3.data))
    } catch(err) {

    }
}

export function* getUsersListSaga(action) {
    try {
        let appUser = yield select(selectors.appUser);
        // console.log(appUser);
        
        const response = yield call(getUsersList, {
            userRole: JSON.parse(localStorage.getItem('userRole')),
            max: appUser.max,
            offset: (appUser.pageNo - 1) * appUser.max,
            sortBy: appUser.sortBy,
            column: appUser.currColumn,
            username: appUser.username,
            first_name: appUser.first_name,
            last_name: appUser.last_name,
            alias: appUser.alias,
            selectedRoles: appUser.selectedRoles,
            business: appUser.selectedBusiness,
            playerType: appUser.selectedPlayerTypes,
            assigned_to: appUser.selectedCoaches
        });
        yield put(actions.setUsersList(response.data.usersList, response.data.count))
    } catch (err) {
        console.log(err);
    }
}

// export function* onOffsetChangeSaga(action) {
//     try{
//         yield put(actions.setOffset(action.offset))
//         let filterData = yield select(selectors.appUser);
//         filterData.column = filterData.currColumn
//         filterData.business = filterData.selectedBusiness
//         filterData.playerType = filterData.player_type
//         // filterData.assigned_to = filterData.selectedCoach, 
//         filterData.userRole = localStorage.getItem('userRole')
//         const response = yield call(getUsersList, filterData) 
//         yield put(actions.setUsersList(response.data.usersList, response.data.count))
//     } catch(err) {
//         console.log(err);
        
//     }
// }



/** WEBPACK FOOTER **
 ** ./src/store/sagas/appUser.js
 **/